import initialState from 'store/hoReducers/fileSystem/initialState';

export default initialState;
